import { ScanAction } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const scanItems = {
  name: "scanItems" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    actions: z.array(
      z.object({
        action: createEnum(ScanAction, { enumName: "ScanAction" }),
        lineItemExternalId: z.string(),
        quantity: z.number(),
      }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
